const BaseView = require('components-framework/view/base.view');
const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();
const ShoppingCart = require('od-modules/cart/cart');
const trackingUtils = require('od-modules/utils/tracking.utils');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const conchitaFactory = require('components/conchita/js/main');
const {trackOncePerPolicy} = require('od-modules/track_events/track.frontevents.additional.products');
const frontendShell = require('od-modules/frontend-shell');

const widgetLoader = createWidgetLoader({
    conchita: ['conchita', conchitaFactory],
});

const FARE_RULES_IDENTIFIER = 'conchita-fare-rules';

const isMeta = () => Odigeo.SessionScope.isMeta ? 1 : 0;
const sendForceSelectionTracking = () => {
    const label = `ancillary_forced_selection_cat:FARERULES_meta:${isMeta()}_pol:none_pag:paxfl`;
    trackingUtils.trackEvent('ancillary_selection', label);
};

module.exports = BaseView.extend({
    selectors: {
        selectionButton: '[data-fare]',
    },
    initialize() {
        websiteConfigCollection.getLoadedPromise().then(() => {
            if (Odigeo.AB.isFarePlusInjectionOF2Mobile || Odigeo.AB.isFarePlusInjectionOF2Desktop) {
                this.listenTo(this.model, 'change', this.sendPriceShellEvent);
            } else {
                this.loadFareRules();
                if (Odigeo.SessionScope.flow !== 'mobile' && Odigeo.AB.sidebarRevamp) {
                    this.listenTo(this.model, 'change', this.updateFareRules);
                } else if (Odigeo.Utils.isMobile() && !Odigeo.SessionScope.isMeta) {
                    this.listenTo(this.model, 'change', this.updateFareRulesIfHasMembershipDetails);
                } else {
                    this.updateFareRules();
                }
            }
        });
    },
    showFareRulesErrors(container) {
        container.animate({
            scrollTop: ($('.conchita.conchita-fare-rules').offset().top) + 'px',
        }, 500);

        sendForceSelectionTracking();

        widgetLoader.get('conchita').execute('dispatch', {
            identifier: FARE_RULES_IDENTIFIER,
            message: 'error',
        });
    },
    showFareRulesErrorsOF2(container) {
        container.animate({
            scrollTop: ($('#flexibility_bundle_container').offset().top) + 'px',
        }, 500);

        frontendShell.execute(({flexibilityBundle}) => {
            flexibilityBundle.showForceSelection();
        });
    },
    sendPriceShellEvent() {
        frontendShell.execute(({flexibilityBundle}) => {
            flexibilityBundle.loadFarePrice({price: this.model.getPrice()});
        });
    },
    loadFareRules() {
        import(/* webpackChunkName: "frontend-fare-rules" */ 'frontend-fare-rules')
            .then((fareRules) => {
                widgetLoader.get('conchita').execute('load', {
                    identifier: FARE_RULES_IDENTIFIER,
                    container: FARE_RULES_IDENTIFIER,
                    component: fareRules.standaloneFareSelector,
                    translationPath: '/secure/translations/fare-rules',
                    data: {
                        formatCurrency: Odigeo.Utils.formatCurrency,
                    },
                    conchitaLiveContent: true,
                    module: 'fare-rules',
                });
                if (Odigeo.Utils.isMobile() && !Odigeo.SessionScope.isMeta) {
                    this.updateFareRulesIfHasMembershipDetails();
                } else {
                    this.updateFareRules();
                }
            });
    },
    updateFareRules() {
        const [fareRule = {}] = ShoppingCart.take.fareRules();
        const {type} = fareRule;

        widgetLoader.get('conchita').execute('dispatch', {
            identifier: FARE_RULES_IDENTIFIER,
            message: 'load',
            data: {
                selectedFare: type,
                price: this.model.getPrice(),
            },
        });
    },
    updateFareRulesIfHasMembershipDetails() {
        if (this.model.get('membershipSubscriptionDetailsDTO')) {
            this.updateFareRules();
        }
    },
    trackOnLoad() {
        this.$el.find(this.selectors.selectionButton).each((_, button) => {
            const $button = $(button);
            trackOncePerPolicy($button);
        });
    },
});
